package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SponsoredBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_back
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_coming_soon
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_footer
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_founding_note
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_cta
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_f1
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_f2
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_f3
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_f4
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_name
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_free_price
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_interest_recorded
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_intro
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_notify_me
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_period_forever
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_period_month
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_f1
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_f2
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_f3
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_f4
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_f5
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_name
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_premium_price
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_f1
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_f2
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_f3
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_f4
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_name
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_standard_price
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_plan_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_dup_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_dup_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_dup_submit_anyway
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_dup_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submit_failed
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submit_sign_in
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submitted_body
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submitted_partial_note
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submitted_done
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submitted_headline
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_submitted_title
import org.jetbrains.compose.resources.stringResource

/**
 * Step 4 — Choose Your Plan (Stitch `43500855`), **honest-monetization variant** (`docs/ROADMAP.md`):
 * payments don't exist yet, so Free ([onContinueFree]) is the only completing action; the paid cards
 * keep their Stitch layout but carry a "coming soon" badge and their CTA becomes founding-business
 * **interest capture** ([onRegisterInterest] — no fake paywall).
 *
 * [submitting]/[submitStatus] mirror the ViewModel's submit flow: the Free CTA shows progress, a
 * failure (or guest sign-in requirement) renders an inline banner, and a successful submit replaces
 * the plan list with a "pending review" confirmation whose Done button fires [onDone].
 */
@Composable
fun AddBusinessPlanScreen(
    draft: AddBusinessDraft,
    submitting: Boolean,
    submitStatus: AddBusinessSubmitStatus?,
    partialUploadFailed: Boolean,
    onContinueFree: () -> Unit,
    onRegisterInterest: (BusinessPlan) -> Unit,
    onDone: () -> Unit,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    duplicateName: String? = null,
    onSubmitAnyway: () -> Unit = {},
    onDismissDuplicate: () -> Unit = {},
) {
    if (submitStatus == AddBusinessSubmitStatus.Submitted) {
        SubmittedConfirmation(onDone = onDone, partialUploadFailed = partialUploadFailed, modifier = modifier)
        return
    }
    WizardScaffold(
        stepIndex = 5,
        title = stringResource(Res.string.ab_plan_title),
        onBack = onBack,
        modifier = modifier,
        bottomBar = {
            AppButton(
                text = stringResource(Res.string.ab_back),
                onClick = onBack,
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "arrow_back",
            )
        },
    ) {
        Text(
            text = stringResource(Res.string.ab_plan_subtitle),
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onSurface,
        )
        Text(
            text = stringResource(Res.string.ab_plan_intro),
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
        )

        if (submitStatus != null) {
            Text(
                text = stringResource(
                    if (submitStatus == AddBusinessSubmitStatus.SignInRequired) Res.string.ab_submit_sign_in
                    else Res.string.ab_submit_failed,
                ),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onErrorContainer,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.errorContainer, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.md),
            )
        }

        // BIZ-7 duplicate guard: a same-named listing already exists in this metro. Most of the time
        // the right move is claiming it, so the warning leads with that; "Submit anyway" stays
        // available for genuine same-name businesses (chains, common names).
        if (duplicateName != null) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = stringResource(Res.string.ab_dup_title),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSecondaryContainer,
                )
                Text(
                    text = stringResource(Res.string.ab_dup_desc, duplicateName),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSecondaryContainer,
                )
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                    AppButton(
                        text = stringResource(Res.string.ab_dup_submit_anyway),
                        onClick = onSubmitAnyway,
                        modifier = Modifier.weight(1f),
                    )
                    AppButton(
                        text = stringResource(Res.string.ab_dup_cancel),
                        onClick = onDismissDuplicate,
                        modifier = Modifier.weight(1f),
                        variant = AppButtonVariant.Secondary,
                    )
                }
            }
        }

        PlanCard(
            name = stringResource(Res.string.ab_plan_free_name),
            price = stringResource(Res.string.ab_plan_free_price),
            period = stringResource(Res.string.ab_plan_period_forever),
            features = listOf(
                stringResource(Res.string.ab_plan_free_f1) to true,
                stringResource(Res.string.ab_plan_free_f2) to true,
                stringResource(Res.string.ab_plan_free_f3) to false,
                stringResource(Res.string.ab_plan_free_f4) to false,
            ),
            highlighted = false,
            badge = null,
            ctaText = stringResource(Res.string.ab_plan_free_cta),
            ctaIcon = "check",
            ctaLoading = submitting,
            onCta = onContinueFree,
        )

        PlanCard(
            name = stringResource(Res.string.ab_plan_premium_name),
            price = stringResource(Res.string.ab_plan_premium_price),
            period = stringResource(Res.string.ab_plan_period_month),
            features = listOf(
                stringResource(Res.string.ab_plan_premium_f1) to true,
                stringResource(Res.string.ab_plan_premium_f2) to true,
                stringResource(Res.string.ab_plan_premium_f3) to true,
                stringResource(Res.string.ab_plan_premium_f4) to true,
                stringResource(Res.string.ab_plan_premium_f5) to true,
            ),
            highlighted = true,
            badge = stringResource(Res.string.ab_plan_coming_soon),
            ctaText = stringResource(
                if (draft.paidPlanInterest == BusinessPlan.Premium) Res.string.ab_plan_interest_recorded
                else Res.string.ab_plan_notify_me,
            ),
            ctaIcon = if (draft.paidPlanInterest == BusinessPlan.Premium) "check" else "notifications",
            onCta = { onRegisterInterest(BusinessPlan.Premium) },
        )

        PlanCard(
            name = stringResource(Res.string.ab_plan_standard_name),
            price = stringResource(Res.string.ab_plan_standard_price),
            period = stringResource(Res.string.ab_plan_period_month),
            features = listOf(
                stringResource(Res.string.ab_plan_standard_f1) to true,
                stringResource(Res.string.ab_plan_standard_f2) to true,
                stringResource(Res.string.ab_plan_standard_f3) to true,
                stringResource(Res.string.ab_plan_standard_f4) to false,
            ),
            highlighted = false,
            badge = stringResource(Res.string.ab_plan_coming_soon),
            ctaText = stringResource(
                if (draft.paidPlanInterest == BusinessPlan.Standard) Res.string.ab_plan_interest_recorded
                else Res.string.ab_plan_notify_me,
            ),
            ctaIcon = if (draft.paidPlanInterest == BusinessPlan.Standard) "check" else "notifications",
            onCta = { onRegisterInterest(BusinessPlan.Standard) },
        )

        Text(
            text = stringResource(Res.string.ab_plan_founding_note),
            style = AppTheme.typography.bodySm,
            color = AppTheme.colors.onSurfaceVariant,
            textAlign = TextAlign.Center,
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
        )
        Text(
            text = stringResource(Res.string.ab_plan_footer),
            style = AppTheme.typography.bodySm,
            color = AppTheme.colors.onSurfaceVariant,
            textAlign = TextAlign.Center,
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
        )
    }
}

/** Full-screen confirmation after a successful submit: the listing is in, pending admin review. */
@Composable
private fun SubmittedConfirmation(
    onDone: () -> Unit,
    partialUploadFailed: Boolean,
    modifier: Modifier = Modifier,
) {
    WizardScaffold(
        stepIndex = 5,
        title = stringResource(Res.string.ab_submitted_title),
        onBack = onDone,
        modifier = modifier,
        bottomBar = {
            AppButton(
                text = stringResource(Res.string.ab_submitted_done),
                onClick = onDone,
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = "check",
            )
        },
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.xl),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIcon(
                name = "check_circle",
                size = AppTheme.sizes.iconHero,
                tint = AppTheme.colors.primary,
            )
            Text(
                text = stringResource(Res.string.ab_submitted_headline),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
                textAlign = TextAlign.Center,
            )
            Text(
                text = stringResource(Res.string.ab_submitted_body),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
            )
            if (partialUploadFailed) {
                InfoNote(stringResource(Res.string.ab_submitted_partial_note))
            }
        }
    }
}

@Composable
private fun PlanCard(
    name: String,
    price: String,
    period: String,
    features: List<Pair<String, Boolean>>,
    highlighted: Boolean,
    badge: String?,
    ctaText: String,
    ctaIcon: String?,
    onCta: () -> Unit,
    ctaLoading: Boolean = false,
) {
    val container = if (highlighted) AppTheme.colors.primaryContainer else AppTheme.colors.surface
    val onContainer = if (highlighted) AppTheme.colors.onPrimary else AppTheme.colors.onSurface
    val muted = if (highlighted) AppTheme.colors.onPrimary else AppTheme.colors.onSurfaceVariant

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(container, AppTheme.shapes.card)
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(text = name, style = AppTheme.typography.labelMd, color = muted)
            if (badge != null) SponsoredBadge(label = badge)
        }
        Row(verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
            Text(text = price, style = AppTheme.typography.headlineLg, color = onContainer)
            Text(
                text = period,
                style = AppTheme.typography.bodySm,
                color = muted,
                modifier = Modifier.padding(bottom = AppTheme.spacing.xs),
            )
        }
        features.forEach { (label, enabled) ->
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppIcon(
                    name = if (enabled) "check_circle" else "cancel",
                    size = AppTheme.sizes.iconSm,
                    tint = if (enabled) (if (highlighted) AppTheme.colors.onPrimary else AppTheme.colors.primary) else muted,
                )
                Text(
                    text = label,
                    style = AppTheme.typography.bodySm,
                    color = if (enabled) onContainer else muted,
                )
            }
        }
        AppButton(
            text = ctaText,
            onClick = onCta,
            modifier = Modifier.fillMaxWidth(),
            variant = if (highlighted) AppButtonVariant.Secondary else AppButtonVariant.Primary,
            enabled = !ctaLoading,
            loading = ctaLoading,
            leadingIcon = ctaIcon,
        )
    }
}
